import { axios, AxiosResponse } from '@/config/plugins/axios';

const navigationService = {
	getByProject(projectToken: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/projects/${projectToken}/navigation`);
	},

	getHomeByProject(projectToken: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/projects/${projectToken}/home`);
	},

	getIndicatorsByProjectAndConfigName(projectToken: string, configName: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/projects/${projectToken}/home/indicators/${configName}`);
	}
};

export default navigationService;
